// SOB / load-share bulk uploads identify a transporter by its CODE only. The name is taken from
// the transporter master, never matched against the file: the same LSP is spelt differently
// across warehouses ('SANDEEP LOGISTICS' / 'SANDEEP LOGISTICS.'), and an exact name match
// rejected correct NAG uploads. A file that still carries a "Transporter Name" column is
// accepted; that column is ignored.

export function normalizeTransporterCode(value) {
    return String(value === undefined || value === null ? "" : value).trim().toUpperCase();
}

// The master row for a code (case / surrounding-space insensitive), or null.
export function findTransporterByCode(transporters, code) {
    const wanted = normalizeTransporterCode(code);
    if (wanted === "") return null;
    return (transporters || []).find((each) => normalizeTransporterCode(each.transporter_code) === wanted) || null;
}
